module.exports = __webpack_public_path__ + "img/back.27dcde5a.jpg";